import { AuthenticationService } from '../services';
import type { LoginRequest } from '../services';

export const checkAuth = () => {
  return AuthenticationService.readUsersMeApiAuthMeGet();
};

export const performLogout = () => {
  return AuthenticationService.logoutApiAuthLogoutPost();
};

export const performLogin = (payload: LoginRequest) => {
  return AuthenticationService.loginApiAuthLoginPost(payload);
};

export type { LoginRequest } from '../services';
